module.exports = "<div :tooltip=fdata.tip class=Form__group><h3 v-if=\"fdata.legend || fdata.label\" class=Form__legend>{{ fdata.legend || fdata.label }}</h3><component v-for=\"field in fdata.content\" :is=field.type :fdata.sync=field></component></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/forms/_sub/subFieldset.vue
// module id = 423
// module chunks = 0